import Router from 'vue-router';
import Vue from 'vue';

import Errors from './views/Errors.vue';
import Bank from './components/pages/bank.vue';
import Calculator from './components/pages/calculator.vue';
import ChangePassword from './components/pages/changePassword.vue';
import Commissions from './components/pages/commissions.vue';
import Dashboard from './components/pages/dashboard';
import Downloads from './components/pages/downloads.vue';
import ForgotPassword from './components/pages/forgotPassword.vue';
import Links from './components/pages/links.vue';
import Login from './components/pages/login.vue';
import MerchantMetrics from './components/pages/merchantMetrics.vue';
import NoteExtracts from './components/pages/noteExtracts.vue';
import PartnerDocs from './components/pages/partnerDocs.vue';
import PartnersMerchant from './components/pages/partnersMerchant/partnersMerchant.vue';
import PartnersMerchantPreview from './components/pages/partnersMerchantPreview/partnersMerchantPreview.vue';
import Prospects from './components/pages/prospects/prospects.vue';
import PartnerData from './components/pages/partnerData.vue';
import ResetPassword from './components/pages/resetPassword.vue';
import UserProfile from './components/pages/userProfile.vue';
import Users from './components/pages/users.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/dashboard',
      name: 'dashboard',
      secure: true,
      meta: {
        layout: 'header-navigation'
      },
      component: Dashboard,
    },
    {
      path: '/',
      name: 'login',
      meta: { layout: 'default' },
      component: Login,
    },
    {
      path: '/administration/bank',
      name: 'Bank',
      secure: true,
      meta: { layout: 'header-navigation' },
      component: Bank,
    },
    {
      path: '/administration/partner-data',
      name: 'partner-data',
      secure: true,
      meta: { layout: 'header-navigation' },
      component: PartnerData,
    },
    {
      path: '/administration/partner-docs',
      name: 'partner-docs',
      meta: { layout: 'header-navigation' },
      component: PartnerDocs,
    },
    {
      path: '/administration/note-extracts',
      name: 'note-extracts',
      secure: true,
      meta: { layout: 'header-navigation' },
      component: NoteExtracts,
    },
    {
      path: '/administration/users',
      name: 'users',
      secure: true,
      meta: { layout: 'header-navigation' },
      component: Users,
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      meta: { layout: 'default' },
      component: ForgotPassword,
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      meta: { layout: 'default' },
      component: ResetPassword,
    },
    {
      path: '/errors',
      name: 'errors',
      component: Errors,
    },
    {
      path: '/deals/prospects',
      name: 'prospects',
      meta: { layout: 'header-navigation' },
      component: Prospects,
    },
    {
      path: '/deals/clients',
      name: 'partners-merchant',
      meta: { layout: 'header-navigation' },
      component: PartnersMerchant,
    },
    {
      path: '/deals/merchant-preview',
      name: 'partners-merchant-preview',
      meta: { layout: 'header-navigation' },
      component: PartnersMerchantPreview,
    },
    {
      path: '/sales/commissions',
      name: 'sales',
      secure: true,
      meta: { layout: 'header-navigation' },
      component: Commissions,
    },
    {
      path: '/sales/links',
      name: 'Links',
      secure: true,
      meta: { layout: 'header-navigation' },
      component: Links,
    },
    {
      path: '/relationship/merchant-metrics',
      name: 'merchant-metrics',
      meta: { layout: 'header-navigation' },
      component: MerchantMetrics,
    },
    {
      path: '/tools/downloads',
      name: 'Downloads',
      secure: true,
      meta: { layout: 'header-navigation' },
      component: Downloads,
    },
    {
      path: '/tools/calculator',
      name: 'Calculator',
      secure: true,
      meta: { layout: 'header-navigation' },
      component: Calculator,
    },
    {
      path: '/user-profile',
      name: 'user-profile',
      meta: { layout: 'header-navigation' },
      component: UserProfile,
    },
    {
      path: '/change-password',
      name: 'change-password',
      meta: { layout: 'header-navigation' },
      component: ChangePassword,
    },
    {
      path: '*',
      redirect: '/errors',
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (router.app.$profileCode() != "1") {
    router.options.routes.forEach((route) => {
      if (to.matched[0].path === route.path && route.secure) {
        return next('/deals/clients');
      }
    });
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js